/*
 * Tracking Event Editor - Event Workflow Warning Dialog
 * Angular Module: trackerbase-app.views.tracking-event-editor.event-workflow-warning-dialog
 * Controller: eventWorkflowWarning
 */
import ngAnimateModule from "angular-animate";
import ngSanitizeModule from "angular-sanitize";
import uiBootstrapModule from "angular-ui-bootstrap";
import kendoDirectivesModule from "../../../shims/kendoDirectives";

import Assert from "tbAssert";



const mModalInstance = new WeakMap();
const mEventPreCheckResult = new WeakMap();
const mEventPreCheckMessages = new WeakMap();

const userOverrideStatusMessage = "USEROVERRIDE";
const userCancelledStatusMessage = "USERCANCEL";

const preCheckBucketsTable = new Map([
    ["AssignedTrackers", "Assigned Trackers"],
    ["EventParticipants", "Event Attendees"],
    ["EventSubscribers", "Subscribers"],
    ["EventTypes", "Event Types"]
]);

class EventWorkflowWarningDialogController {
    constructor($uibModalInstance, preCheckResult) {
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing UI Modal Instance Dependency");
        mModalInstance.set(this, $uibModalInstance);
        mEventPreCheckResult.set(this, preCheckResult);
        mEventPreCheckMessages.set(this, null);
    }

    $onInit() {
        let eventPreCheckResult = mEventPreCheckResult.get(this);
        if ((eventPreCheckResult != null) && (eventPreCheckResult.preCheckMessages != null)) {
            let eventPreCheckMessageData = Object.keys(eventPreCheckResult.preCheckMessages).map((bucketName) => {
                let normalizedBucketName = preCheckBucketsTable.get(bucketName);
                if (normalizedBucketName == null) {
                    normalizedBucketName = "Other";
                }

                return {
                    msgBucketName: normalizedBucketName,
                    msgBucketContent: eventPreCheckResult.preCheckMessages[bucketName]
                };
            });

            mEventPreCheckMessages.set(this, eventPreCheckMessageData);
        }
    }

    get eventPreCheckPassed() {
        return mEventPreCheckResult.get(this).preCheckPassed;
    }

    get eventPreCheckMessages() {
        return mEventPreCheckMessages.get(this);
    }

    //noinspection JSUnusedGlobalSymbols
    get eventPreCheckMessageCount() {
        if (Array.isArray(this.eventPreCheckMessages) === true) {
            return this.eventPreCheckMessages.length;
        }
        else {
            return 0;
        }
    }

    overrideWarnings() {
        mModalInstance.get(this).close(userOverrideStatusMessage);
    }

    cancelWorkflow() {
        mModalInstance.get(this).dismiss(userCancelledStatusMessage);
    }
}

EventWorkflowWarningDialogController.UserOverrideStatusMessage = userOverrideStatusMessage;
EventWorkflowWarningDialogController.UserCancelledStatusMessage = userCancelledStatusMessage;

EventWorkflowWarningDialogController.$inject = [
    "$uibModalInstance",
    "preCheckResult"
];

EventWorkflowWarningDialogController.dependencies = [
    ngAnimateModule,
    ngSanitizeModule,
    uiBootstrapModule,
    kendoDirectivesModule
];

EventWorkflowWarningDialogController.template = require("./EventWorkflowWarningDialog.tpl.html");

EventWorkflowWarningDialogController.controllerAs = "eventWorkflowWarning";

export default EventWorkflowWarningDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/event-workflow-warning-dialog/EventWorkflowWarningDialogController.js
// module id = 8HbE
// module chunks = 1